import React from "react";
import { Row, Col, Image, Button, Table, Spinner } from "react-bootstrap";
import close from "./../../assets/images/close.png";
import tickmark from "./../../assets/icons/tickmark.png";

export default ({
  availability,
  loading,
  user,
  tutor,
  firstName,
  lastName,
  isStudentsearch,
  isDashboard,
  forBooking,
  isSmaller
}) => {
  return(
    <div className="availability">
      <p className="availability-headline" >Availability</p>
        <Row className="m-0">
          <Col className="offset-3 col-mrgn-right day-center-jusitification" xs={1}><p className="day-row-font">Mo</p></Col>
          <Col className="col-mrgn-right day-center-jusitification" xs={1}><p className="day-row-font">Tu</p></Col>
          <Col className="col-mrgn-right day-center-jusitification" xs={1}><p className="day-row-font">We</p></Col>
          <Col className="col-mrgn-right day-center-jusitification" xs={1}><p className="day-row-font">Th</p></Col>
          <Col className="col-mrgn-right day-center-jusitification" xs={1}><p className="day-row-font">Fr</p></Col>
          <Col className="col-mrgn-right day-center-jusitification" xs={1}><p className="day-row-font">Sa</p></Col>
          <Col className="col-mrgn-right day-center-jusitification" xs={1}><p className="day-row-font">Su</p></Col>
        </Row>
      { availability && availability.map((value, index) => {
        return (
          <Row className="m-0">
            <Col className="col-mrgn-right" xs={3}>
              <p className="col-font-det">{value.timeStatus?value.timeStatus:"Morning"}</p>
              <p className="col-font-det day-sim-font-wt">{value.time?value.time:"Pre 12pm"}</p>
            </Col>
            <Col className={value?.week?.mon !== "unavailable"?"padding-for-bx-img-t":"padding-for-bx-img-c"} xs={1}><img src={value?.week?.mon !== "unavailable"?tickmark:close} className="img-fluid" /></Col>
            <Col className={value?.week?.tues !== "unavailable"?"padding-for-bx-img-t":"padding-for-bx-img-c"} xs={1}><img src={value?.week?.tues !== "unavailable"?tickmark:close} className="img-fluid" /></Col>
            <Col className={value?.week?.wed !== "unavailable"?"padding-for-bx-img-t":"padding-for-bx-img-c"} xs={1}><img src={value?.week?.wed !== "unavailable"?tickmark:close} className="img-fluid" /></Col>
            <Col className={value?.week?.thus !== "unavailable"?"padding-for-bx-img-t":"padding-for-bx-img-c"} xs={1}><img src={value?.week?.thus !== "unavailable"?tickmark:close} className="img-fluid" /></Col>
            <Col className={value?.week?.fri !== "unavailable"?"padding-for-bx-img-t":"padding-for-bx-img-c"} xs={1}><img src={value?.week?.fri !== "unavailable"?tickmark:close} className="img-fluid" /></Col>
            <Col className={value?.week?.sat !== "unavailable"?"padding-for-bx-img-t":"padding-for-bx-img-c"} xs={1}><img src={value?.week?.sat !== "unavailable"?tickmark:close} className="img-fluid" /></Col>
            <Col className={value?.week?.sun !== "unavailable"?"padding-for-bx-img-t":"padding-for-bx-img-c"} xs={1}><img src={value?.week?.sun !== "unavailable"?tickmark:close} className="img-fluid" /></Col>
          </Row>
      );})}
      <div>
      { isSmaller?
        <button className="btn btn-success set-av-btn">Set Availability</button>
        :
        <React.Fragment>
          <div className="mrng-tp-end-info">
            <img src={tickmark} className="end-img-with-info-t" style={{marginRight: "5px"}}/>
            <span>{`${firstName ? firstName : ""} is available to tutor`}</span>
          </div>
          <div style={{marginTop: "8px"}}>
            <img src={close} className="end-img-with-info-c" style={{marginRight: "5px"}}/>
            <span>{`${firstName ? firstName : ""} is unavailable`}</span>
          </div>
        </React.Fragment>
      }
      </div>
    </div>
  );
}
